import bigData from '../../assets/services/bigData.svg'
import blockchain from '../../assets/services/blockchain.svg'
import dataScraping from '../../assets/services/dataScraping.svg'
import devOps from '../../assets/services/devOps.svg'
import EnterPrise from '../../assets/services/EnterPrise.svg'
import lotDevelopment from '../../assets/services/lotDevelopment.svg'
import mobApp from '../../assets/services/mobApp.svg'
import webApp from '../../assets/services/webApp.svg'
import ui from '../../assets/services/ui.svg'
import productServices from '../../assets/services/productServices.svg'
import Software from '../../assets/services/Software.svg'
import SoftwareProject from '../../assets/services/SoftwareProject.svg'
import TechnicalSupport from '../../assets/services/TechnicalSupport.svg'
import TrainingServices from '../../assets/services/TrainingServices.svg'
import customerSupport from '../../assets/services/customerSupport.svg'

import ecommerce from '../../assets/industries/ecommerce.svg'
import education from '../../assets/industries/education.svg'
import fintech from '../../assets/industries/fintech.svg'
import food from '../../assets/industries/food.svg'
import healthCare from '../../assets/industries/healthcare.svg'
import onedemand from '../../assets/industries/ondemand.svg'
import travel from '../../assets/industries/travel.svg'

import data from '../../assets/hire/data.svg'
import elixir from '../../assets/hire/elixir.svg'
import flutter from '../../assets/hire/flutter.svg'
import nodejs from '../../assets/hire/nodejs.svg'
import penetration from '../../assets/hire/penetration.svg'
import python from '../../assets/hire/pythone.svg'
import ror from '../../assets/hire/ror.svg'
import unreal from '../../assets/hire/unreal.svg'

import blog from '../../assets/content/blog.svg'
import ebook from '../../assets/content/ebooks.svg'
import invonews from '../../assets/content/invonews.svg'
import invotalks from '../../assets/content/invotalks.svg'

import about from '../../assets/company/about.svg'
import career from '../../assets/company/career.svg'
import portfolio from '../../assets/company/portfolio.svg'
import presshq from '../../assets/company/presshq.svg'
import react from '../../assets/services-web-App/tech/img13.svg'


export const services = [
    {
        title: 'web app development services',
        icon: webApp,

    },
    {
        title: 'metaverse development',
        icon: devOps,

    },
    {
        title: 'NFT marketplaces platforms',
        icon: SoftwareProject,

    },
    {
        title: 'mob app development servies',
        icon: webApp,

    },
    {
        title: 'webGL development',
        icon: dataScraping,

    },
    {
        title: 'software development',
        icon: TechnicalSupport,

    },
    {
        title: 'artificial intelligence',
        icon: bigData,

    },
    {
        title: 'ui/ux design',
        icon: ui,

    },
    {
        title: 'robotics',
        icon: Software,

    },
    {
        title: 'automation testing',
        icon: lotDevelopment,

    },
    {
        title: 'quality assurance',
        icon: customerSupport,

    },
    {
        title: 'blockchain development',
        icon: blockchain,

    },
    {
        title: 'ebook cover making',
        icon: productServices,

    },
    {
        title: 'e-book writting both fiction and non fiction',
        icon: TrainingServices,

    },
    {
        title: 'content writing',
        icon: onedemand,

    },

]

export const industries = [
    {
        title: 'E commerce',
        icon: ecommerce,

    },
    {
        title: 'on demand services',
        icon: onedemand,

    },
    {
        title: 'fintech',
        icon: fintech,

    },
    {
        title: 'food & delivery',
        icon: food,

    },
    {
        title: 'healthcare',
        icon: healthCare,

    },
    {
        title: 'travel & tourism',
        icon: travel,

    },
    {
        title: 'education',
        icon: education,

    },
]

export const Hire = [

    {
        title: 'hire nodejs developer',
        icon: nodejs,

    },
    {
        title: 'hire react developer',
        icon: react,

    },
    {
        title: 'hire flutter developer',
        icon: flutter,

    },
    {
        title: 'hire python developer',
        icon: python,

    },
    {
        title: 'hire data engineers',
        icon: data,

    },
    {
        title: 'hire automation engineers',
        icon: fintech,

    },
    {
        title: 'hire sqa engineers',
        icon: customerSupport,

    },
]

export const Content = [
    {
        title: 'blogs',
        icon: blog,

    },
    {
        title: 'codeTalks',
        icon: invotalks,

    },
    {
        title: 'codeNews',
        icon: invonews,

    },
    {
        title: 'e books',
        icon: ebook,

    },
    {
        title: 'content writing',
        icon: onedemand,

    },
]

export const company = [
    {
        title: 'about us',
        icon: about,

    },
    {
        title: 'career',
        icon: career,

    },
    {
        title: 'protfolio',
        icon: portfolio,

    },
    {
        title: 'press hq',
        icon: presshq,

    },
]